import React from 'react';
import { ShieldCheck, Activity } from 'lucide-react';
import SEO from '../components/SEO';
import SpecialtyPageTemplate from '../components/SpecialtyPageTemplate';

const PharmacyPage = () => {
  const config = {
    badge: "Clinical Pharmacy",
    headline: "In-House",
    headlineItalic: "Pharmacy.",
    subtext: "A fully-stocked, licensed veterinary pharmacy ensuring your pet receives the correct medication, dose, and formulation — dispensed right here on-site.",
    image: "/images/services/diagnostics_lab.png",
    imageAlt: "Veterinary Pharmacy at Dr. Suresh Pet Care — In-House Dispensary",
    stats: [
      { value: 500, suffix: '+', label: 'Medicines Stocked' },
      { value: 100, suffix: '%', label: 'Licensed Medicines' },
      { value: 24, suffix: '/7', label: 'Emergency Dispensing' },
      { value: 10, suffix: '+', label: 'Years Expertise' },
    ],
    services: [
      {
        title: "Prescription Dispensing",
        icon: <Activity size={28} />,
        desc: "Accurate prescription filling with dosage counseling and species-specific formulation advice.",
        specs: ["Antibiotics", "Anti-parasitics", "Hormonal Therapies", "Analgesics"],
        color: "from-green-500/10 to-primary/10"
      },
      {
        title: "Emergency Medicines",
        icon: <ShieldCheck size={28} />,
        desc: "Critical care drugs and emergency agents available at all hours for rapid stabilization requirements.",
        specs: ["Adrenaline", "IV Antibiotics", "Diuretics", "Anti-seizure Drugs"],
        color: "from-red-500/10 to-primary/10"
      },
      {
        title: "Supplements & Nutrition",
        icon: <ShieldCheck size={28} />,
        desc: "Veterinary-recommended nutritional supplements, prescription diets, and therapeutic food formulas.",
        specs: ["Joint Supplements", "Omega Fatty Acids", "Prescription Diets", "Probiotics"],
        color: "from-primary/10 to-amber-500/10"
      }
    ],
    sectionTitle: "Our Pharmacy",
    sectionItalic: "Services.",
    warningTitle: "Medication",
    warningItalic: "Safety.",
    warningText: "Veterinary medications require precise species-specific dosing. Only use medications prescribed and dispensed by licensed veterinary professionals.",
    warnings: [
      { name: "No Human Meds", desc: "Never give human medications to pets — many are highly toxic to animals.", icon: "⚠️" },
      { name: "Correct Dosing", desc: "Pet weight and species determine safe dosing — never estimate or share doses.", icon: "💊" },
      { name: "Proper Storage", desc: "Most veterinary medications require specific temperature or storage conditions.", icon: "🌡️" },
      { name: "Complete Course", desc: "Always complete prescribed antibiotic or anti-parasitic courses to prevent resistance.", icon: "✅" },
    ],
    ctaBadge: "Licensed Pharmacy",
    ctaTitle: "The Pharmacy",
    ctaItalic: "Expertise.",
    ctaText: "Our in-house pharmacy stocks a comprehensive range of licensed veterinary medications, enabling same-visit dispensing and ensuring medication accuracy.",
    ctaBtn: "Visit Our Pharmacy",
    seoText: "Veterinary pharmacy in Hyderabad. Prescription pet medications and supplements at Dr. Suresh Pet Care pharmacy. In-house veterinary dispensary.",
    glowColor: "green-500"
  };

  return (
    <>
      <SEO 
        title="Veterinary In-House Pharmacy"
        description="Complete in-house veterinary pharmacy at Dr. Suresh Pet Care, Hyderabad. Prescription medications, supplements, and specialty drugs dispensed on-site."
        canonical="/pharmacy"
      />
      <SpecialtyPageTemplate config={config} />
    </>
  );
};


export default PharmacyPage;
